import { formatStringForTemplating } from "@/backend/helpers/utils";
import { useParseProcedureReferences } from "@/frontend/hooks/parameters";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { ParameterSubjectType, ParameterType } from "@/types/parameterTypes";
import { Form } from "react-bootstrap";


export function TitleAndIdentifierAndDescriptionFormInputs({ title, setTitle, titleError, setTitleError, identifier, setIdentifier, identifierError, identifierOptional, setIdentifierError, description, setDescription, subjectId, subjectType, parameterType }: { title: string, setTitle: (value: string) => void, titleError: string | undefined, setTitleError: (value: string | undefined) => void, identifier: string, setIdentifier: (value: string) => void, identifierError: string | undefined, identifierOptional: boolean, setIdentifierError: (value: string | undefined) => void, description: string, setDescription: (value: string) => void, subjectId: string, subjectType: ParameterSubjectType, parameterType: ParameterType }) {
  const parameterIdentifierInvalid = useParameterStore(state => state.parameterIdentifierInvalid);
  const parseProcedureReferences = useParseProcedureReferences({ rangeParameterId: '', parentId: subjectId });

  const onChangeIdentifier = (value: string) => {
    setIdentifier(value);
    const error = parameterIdentifierInvalid({ identifier: value, subjectId, subjectType, type: parameterType });
    if (error) setIdentifierError(error);
    else setIdentifierError(undefined);
  };

  const setTitleWrapper = (value: string) => {
    setTitle(value);
    setTitleError(parseProcedureReferences(value) || '');
  };

  const autoSetIdentifier = (newTitle: string) => {
    if (identifier) return;
    const newIdentifier = formatStringForTemplating(newTitle);
    if (!parameterIdentifierInvalid({ identifier: newIdentifier, subjectId, subjectType, type: parameterType })) {
      setIdentifier(newIdentifier);
      setIdentifierError('');
    }
  };

  const identifierLabel = identifierOptional ? `${I18n.get('identifier')} (${I18n.get('optional')})` : I18n.get('identifier');

  return (
    <>
      <Form.Label>{I18n.get('title')}</Form.Label>
        <Form.Control
          aria-label={I18n.get('enterField', { field: I18n.get('title') })}
          value={title}
          isInvalid={!!titleError}
          onChange={(event) => setTitleWrapper(event.target.value)}
          onBlur={() => autoSetIdentifier(title)}
        />
        <Form.Control.Feedback type="invalid">
          { titleError }
        </Form.Control.Feedback>
        {parameterType !== ParameterType.INTRODUCTION && <>
          <Form.Label className='mt-3'>{identifierLabel}</Form.Label>
          <Form.Control
            aria-label={I18n.get('enterField', { field: I18n.get('identifier') })}
            value={identifier}
            isInvalid={!!identifierError}
            onChange={(event) => onChangeIdentifier(event.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            { identifierError }
          </Form.Control.Feedback>
        </>}
        <Form.Label className='mt-3'>{I18n.get('description')} ({I18n.get('optional')})</Form.Label>
        <Form.Control
          as="textarea"
          aria-label={I18n.get('enterField', { field: I18n.get('description') })}
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
    </>
  );
}
